import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Button, Card, Col, Divider, Form, Input, Row, Spin, Typography, message } from "antd";
import { CheckCircleFilled, LoadingOutlined } from "@ant-design/icons";
import BG from "../../../assets/images/Admin_desktopBG.png";
import { QRcode } from "../service/QRcode.service";
import { useId24 } from "../../../drivers/id24/Id24Provider";
import { Iuser, Iagenda } from "../common";
import dayjs from "dayjs";
import { loadAppConfig } from "../../../configs/app-config";

const antIcon = <LoadingOutlined className="text-[24px]" spin />;

export const DetailafterscanQrcode: React.FC = (): React.ReactElement => {
  const { id24Axios } = useId24();
  const apiBaseUrl = id24Axios(loadAppConfig().REACT_APP_API_BASE_URL);
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  // 1 solution
  const userId = params.get("userid");
  const agendaId = params.get("agendaid");
  const [masterDataAgenda, setMasterdataAgenda] = useState<Iagenda[]>();
  const [masterDataUser, setMasterdataUser] = useState<Iuser>();
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    QRcode(apiBaseUrl)
      .getdatauserByagendaid(userId)
      .then((resultUser) => {
        setMasterdataUser(resultUser);
        QRcode(apiBaseUrl)
          .getdataagendaByagendaid(agendaId)
          .then((resultAgenda) => {
            setMasterdataAgenda(resultAgenda);
            setLoading(false);
          });
      });
  }, [agendaId, userId]);

  const handleupdatestatus = async () => {
    const data = {
      registerStatus: true,
    };
    await QRcode(apiBaseUrl)
      .updatecheckin(data, userId)
      .then((update) => {
        if (update.userId) {
          message.success("อัพเดตสำเร็จ");
        } else {
          message.error("ไม่สำเร็จ");
        }
      });
  };

  return loading ? (
    <Row>
      <Col offset={12}>
        <Spin indicator={antIcon} />
      </Col>
    </Row>
  ) : (
    <>
      <div className="w-full p-10 bg-cover bg-no-repeat bg-center" style={{ backgroundImage: `url(${BG})` }}>
        <Card className="w-full rounded-[20px]">
          <div className="flex justify-center mb-2.5">
            <Row gutter={[8, 8]}>
              <Col span={24} className="flex justify-center">
                <CheckCircleFilled className="text-[100px] text-[#F2BE22]" />
              </Col>
              <Col span={24} className="flex justify-center">
                <Typography className="text-[100%] font-bold">{`Please fill out the information below to confirm your participation`}</Typography>
              </Col>
            </Row>
          </div>
          {masterDataUser && (
            <Form
              name={"formuser"}
              labelCol={{ span: 4 }}
              wrapperCol={{ span: 14 }}
              fields={[
                {
                  name: ["fullName"],
                  value: `${masterDataUser?.fullName}`,
                },
                {
                  name: ["numberId"],
                  value: masterDataUser?.numberId,
                },
                {
                  name: ["phone"],
                  value: masterDataUser?.phone,
                },
                {
                  name: ["position"],
                  value: masterDataUser?.position,
                },
                {
                  name: ["department"],
                  value: masterDataUser?.department,
                },
                {
                  name: ["email"],
                  value: masterDataUser?.email,
                },
                {
                  name: ["company"],
                  value: masterDataUser?.company,
                },
              ]}
            >
              <Form.Item name={"fullName"} label={`Name-Surname`}>
                <Input readOnly />
              </Form.Item>
              <Form.Item name={"numberId"} label={`Number ID`}>
                <Input readOnly />
              </Form.Item>
              <Form.Item name={"company"} label={`Company`}>
                <Input readOnly />
              </Form.Item>
              <Form.Item name={"position"} label={`Position`}>
                <Input readOnly />
              </Form.Item>
              <Form.Item name={"email"} label={`Business Email`}>
                <Input readOnly />
              </Form.Item>
            </Form>
          )}

          <Divider />
          <Typography className="text-base font-bold">{`Event Information`}</Typography>
          {masterDataAgenda && (
            <Form
              name="foragenda"
              labelCol={{ span: 4 }}
              wrapperCol={{ span: 14 }}
              fields={[
                {
                  name: ["name"],
                  value: `${masterDataAgenda[0]?.name}`,
                },
                {
                  name: ["description"],
                  value: masterDataAgenda[0]?.description,
                },
                {
                  name: ["number"],
                  value: masterDataAgenda[0]?.number,
                },
                {
                  name: ["numberChar"],
                  value: masterDataAgenda[0]?.numberChar,
                },
                {
                  name: ["type"],
                  value: masterDataAgenda[0]?.type,
                },
                {
                  name: ["seatno"],
                  value: masterDataUser?.seatno,
                },
              ]}
            >
              <Form.Item name={"name"} label={`Event Name`}>
                <Input readOnly />
              </Form.Item>
              <Form.Item name={"seatno"} label={`Seat no.`}>
                <Input readOnly />
              </Form.Item>
            </Form>
          )}
          <div style={{ justifyContent: "center", display: "flex" }}>
            <Button
              disabled={!dayjs(new Date()).isSame(dayjs("2023-07-05"), "day")}
              type="primary"
              onClick={() => {
                handleupdatestatus();
              }}
            >{`Check-in`}</Button>
          </div>
        </Card>
      </div>
    </>
  );
};
